import { createFileRoute } from "@tanstack/react-router";
import TarifasPage from "@/pages/TarifasPage";
import { landingHead } from "@/lib/landingHead";
import { pricingJsonLd } from "@/lib/pricingJsonLd";

export const Route = createFileRoute("/tarifas")({
  head: () => ({
    ...landingHead("pricing", "es"),
    scripts: [{ type: "application/ld+json", children: JSON.stringify(pricingJsonLd("es")) }],
  }),
  component: () => <TarifasPage routeLang="es" />,
  errorComponent: () => <TarifasPage routeLang="es" />,
  notFoundComponent: () => <TarifasPage routeLang="es" />,
});
